<template>
  <div style="margin-top: 100px;">
    Contact tech support here
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
